import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input, Dropdown, Menu, Icon, DatePicker } from 'antd'

// icon
import { FaPlusCircle, FaFileExport } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/object/actions'
import { DownOutlined, UserOutlined } from '@ant-design/icons';

const { MonthPicker, RangePicker } = DatePicker


const { Search } = Input

class HeadBar extends Component {
    state = {
        begin_time: 0,
        end_time: 0,
        type_search: '',
        display_type: 'Toàn bộ trường dữ liệu',
        range_time: []
    }
    _handleAddClick = () => {
        this.props.setDefaultCurrentObject()
        this.props.showModalCurrentObjectInfo()
    }

    onChangeTime = e => {
        this.setState({ range_time: e })
        if (e && e.length > 0) {
            const starttime = (e[0]._d.valueOf() / 1000) >> 0
            const endtime = (e[1]._d.valueOf() / 1000) >> 0
            this.setState({ begin_time: starttime, end_time: endtime })
            this.props.updateParamSearch(starttime, endtime, '')
        } else {
            this.setState({ begin_time: 0, end_time: 0 })
            this.props.updateParamSearch(0, 0, '')
        }

    }

    render() {
        console.log('this.state', this.state)
        const menu = (
            <Menu onClick={e => {
                console.log("e.key", e)
                if (e.key !== '0') {
                    this.setState({ type_search: e.key, display_type: e.item.props.children })
                    this.props.updateParamSearch(0, 0, e.key)
                } else {
                    this.setState({ type_search: '', display_type: e.item.props.children })
                    this.props.updateParamSearch(0, 0, '')
                }


            }}>
                <Menu.Item key="0" icon={<Icon type="user" />}>
                    Toàn bộ trường dữ liệu
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectHashtag" icon={<Icon type="user" />}>
                    HashTag
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectName" icon={<Icon type="user" />}>
                    Họ tên
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectDesc" icon={<Icon type="user" />}>
                    Mô tả
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectAge" icon={<Icon type="user" />}>
                    Năm sinh
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectHomeTown" icon={<Icon type="user" />}>
                    Quê quán
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectLinkFB" icon={<Icon type="user" />}>
                    Link Facebook
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectLinkInsta" icon={<Icon type="user" />}>
                    Link Instagram
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectPhone" icon={<Icon type="user" />}>
                    Số điện thoại
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectEmail" icon={<Icon type="user" />}>
                    Email
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectWork" icon={<Icon type="user" />}>
                    Công việc
                </Menu.Item>
                <Menu.Item key="TypeSearchObjectEducation" icon={<Icon type="user" />}>
                    Học vấn
                </Menu.Item>
            </Menu>
        );
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddClick()}
                    >
                        <FaPlusCircle className="iconButton" />
                        Thêm đối tượng
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => this.props.showModalExportObject(true)}
                        style={{ marginLeft: 15 }}
                    >
                        <FaFileExport className="iconButton" />
                        Xuất ra file
                    </Button>
                </div>
                <div>
                    <RangePicker
                        format="DD/MM/YYYY"
                        renderExtraFooter={() =>
                            'Hiển thị biểu đồ theo thời gian'
                        }
                        onChange={this.onChangeTime}
                        value={this.state.range_time}
                        placeholder={[
                            'Thời gian đầu',
                            'Thời gian cuối',
                        ]}
                        // disabled={this.props.textSearch === ''}
                        showTime
                        style={{ marginRight: 20 }}
                    />
                    <Dropdown overlay={menu}>
                        <Button style={{ height: 32, marginRight: 20 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'center' }}>
                                <text>{this.state.display_type}</text>
                                {/* <DownOutlined style={{ marginLeft: 10 }} /> */}
                                <Icon style={{ marginLeft: 10 }} type="down" />
                            </div>

                        </Button>
                    </Dropdown>

                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => {
                            this.props.searchObject(this.state.begin_time, this.state.end_time, this.state.type_search)
                        }}
                        onChange={e => {
                            if (e.target.value === '') {
                                // this.props.loadListObject({
                                //     page_number: 1,
                                //     page_size: 24,
                                //     status: 0,
                                // })
                                this.setState({ begin_time: 0, end_time: 0 })
                                this.setState({ range_time: [] })
                                this.props.updateParamSearch(0, 0, '')

                                this.props.updateTextSearch('')
                            } else {
                                this.props.updateTextSearch(e.target.value)
                            }
                        }}
                    // value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.object.textSearch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateParamSearch: (begin, end, type) => {
            dispatch(objectActions.action.updateParamSearch(begin, end, type))
        },
        showModalCurrentObjectInfo: () => {
            dispatch(objectActions.action.showModalCurrentObjectInfo())
        },
        showModalExportObject: (visible) => {
            dispatch(objectActions.action.visibleModalExportObject(visible))
        },
        setDefaultCurrentObject: () => {
            dispatch(objectActions.action.setDefaultCurrentObject())
        },
        updateTextSearch: textSearch => {
            dispatch(objectActions.action.updateTextSearch(textSearch))
        },
        searchObject: (begin_time, end_time, type_search) => {
            dispatch(objectActions.action.searchObject(begin_time, end_time, type_search))
        },
        loadListObject: params => {
            dispatch(objectActions.action.loadListObject(params))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
